<ng-container *ngIf="allData$ | async as allData">
  <h1>{{widgetTitle}}</h1>
  <div>
    <mat-form-field class="full-width">
      <input matInput [autofocus]="true" placeholder="Buscar personas o lista de personas" #searchBox
             (keyup)="filter($event.target.value)">
    </mat-form-field>
  </div>
  <div class="peopleManager__lists">
    <section class="peopleManager__singleList" *ngIf="allData.fromList">
      <div class="mat-chip-frame">
        <h4 class="mat-h4">{{fromListTitle}}</h4>
        <div class="flex-wrap" style="align-items: center"
             *ngIf="true else noResults">
          <button mat-raised-button
                  *ngIf="allData.fromList.length > 0; else noResults"
                  (click)="selectAllToAdd(allData.fromList);">{{allSelectedCtrl ? 'Seleccionar ninguno' : 'Seleccionar todos'}}</button>
          <div class="spacer"></div>
          <button mat-raised-button
                  (click)="addSelection(allData.fromList)"
                  *ngIf="allSelectedCtrl" matTooltip="Agregar selección"
                  color="primary">
            Agregar selección
          </button>
        </div>
        <ng-template #noResults>
          <div class="opacity-medium mat-small">Sin resultados</div>
        </ng-template>
        <mat-list>
          <ng-container *ngFor="let person of allData.fromList">
            <mat-list-item>
              <div class="flex-wrap" style="align-items: center">
                <mat-checkbox #addCheckbox
                              [value]="person"
                              [checked]="person.isSelected"
                              (change)="selectedPersonStatus(person, $event.checked)"
                              *ngIf="allSelectedCtrl"
                              color="primary"
                              style="margin-right: 4px;"></mat-checkbox>
                {{person.apellidosNombres}}
              </div>
              <span class="spacer"></span>
              <button mat-icon-button (click)="addToNotifyList(person)" *ngIf="!allSelectedCtrl">
                <mat-icon>add_circle</mat-icon>
              </button>
              <mat-divider></mat-divider>
            </mat-list-item>
          </ng-container>
        </mat-list>
      </div>
    </section>
    <section class="peopleManager__singleList" *ngIf="allData.toList as selectedPeopleList">
      <div class="mat-chip-frame">
        <h4 class="mat-h4">{{toListTitle}}</h4>
        <div class="flex-wrap" style="align-items: center;">
          <!--*ngIf="selectedPeopleList.length > 0; else noSelectedPeople">-->
          <!-- <span class="inline-flex">Seleccionar:</span> -->
          <button mat-raised-button
                  *ngIf="(selectedPeopleList && selectedPeopleList.length > 0)"
                  (click)="selectAllToRemove(selectedPeopleList)">Seleccionar todos
          </button>
          <span class="spacer"></span>
          <button mat-raised-button
                  (click)="removeSelection(selectedPeopleList)"
                  *ngIf="allRemoveCtrl"
                  color="primary">
            Remover selección
          </button>
        </div>
        <ng-template #noSelectedPeople>
          <div class="opacity-medium mat-small">Sin selección</div>
        </ng-template>
        <mat-list>
          <ng-container *ngFor="let selectedPerson of selectedPeopleList">
            <mat-list-item>
              <div class="flex-wrap" style="align-items: center">
                <mat-checkbox #removeCheckbox
                              [value]="selectedPerson"
                              [checked]="selectedPerson.isSelected"
                              (change)="selectedPersonStatus(selectedPerson, $event.checked)"
                              *ngIf="allRemoveCtrl"
                              color="primary"
                              style="margin-right: 4px;"></mat-checkbox>
                {{selectedPerson.apellidosNombres}}

                <div>
                  <ul>
                    <li *ngFor="let role of selectedPerson.roles">{{role.nombre}}</li>
                  </ul>
                </div>
              </div>
              <span class="spacer"></span>
              <div style="position: relative">
                <button mat-icon-button (click)="removeFromNotifyList(selectedPerson)" *ngIf="!allRemoveCtrl">
                  <mat-icon>remove_circle</mat-icon>
                </button>
              </div>
              <mat-divider></mat-divider>
            </mat-list-item>
          </ng-container>
        </mat-list>
      </div>
    </section>
  </div>
  <div *ngIf="showComment" class="full-width">
    <br>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Comentario</mat-label>
      <textarea matInput [formControl]="commentCtrl"></textarea>
    </mat-form-field>
  </div>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="">Cancelar</button>
    <button mat-raised-button color="primary" (click)="notify(allData.toList)"
            [disabled]="allData.toList.length === 0">Aceptar
    </button>
  </mat-dialog-actions>
</ng-container>
